(function () {

  // Tracking event
  document.querySelectorAll(".complete-products").forEach(
    element => {
      element.addEventListener("click", () => {
        window.gtag("event", "complete_the_look", {
          title: element.dataset.title,
          page_location: window.location.href
        });
      });
    }
  );

  document.querySelectorAll(".shop-this-look__grid").forEach(
    element => {
      element.addEventListener("click", () => {
        window.gtag("event", "shop_the_look", {
          title: element.dataset.title,
          image: element.dataset.image,
          page_location: window.location.href
        });
      });
    }
  );

  document.querySelectorAll(".ws-list").forEach(
    element => {
        element.addEventListener("click", () => {
            window.gtag("event", "watch_shop", {
                title: element.dataset.title,
                page_location: window.location.href
            });
        });
    }
  );

  const $ = s => document.querySelector(s);

  let product = null;
  let currentVariantId = null;
  let resolving = false;

  function formatDate(days) {
    const d = new Date();
    d.setDate(d.getDate() + Number(days));

    return `${String(d.getDate()).padStart(2, '0')}/${String(
      d.getMonth() + 1
    ).padStart(2, '0')}`;
  }

  function getForm() {
    return document.querySelector(
      'form[data-type="add-to-cart-form"]'
    );
  }

  function getVariantInput() {
    return getForm()?.querySelector('input[name="id"]');
  }

  function getVariantId() {
    return Number(getVariantInput()?.value) || null;
  }

  function getPreorderVariant(id) {
    const el = $('#preorder-variants');

    if (!el || !id) {
      return null;
    }

    try {
      const variants = JSON.parse(el.textContent || '[]');

      return (
        variants.find(v => Number(v.id) === Number(id)) || null
      );
    } catch (e) {
      console.error('[Preorder] Cannot parse variants:', e);
      return null;
    }
  }

  function updateStockNotice(variant) {
    const box = $('#stock-quantity-notice');

    if (!box) return;

    const text = box.querySelector('.stock-quantity-notice__text');

    if (!variant || !text) {
      box.hidden = true;
      return;
    }

    const inventory = Number(
      variant.inventoryQuantity ??
      variant.inventory_quantity ??
      0
    );

    if (
      variant.available === true &&
      inventory > 0 &&
      inventory < 5
    ) {
      text.textContent = `Chỉ còn ${inventory} sản phẩm`;
      box.hidden = false;
    } else {
      text.textContent = '';
      box.hidden = true;
    }
  }

  async function loadProduct() {
    if (product) {
      return product;
    }

    try {
      const response = await fetch(`${window.location.pathname}.js`);

      if (!response.ok) {
        throw new Error(`HTTP ${response.status}`);
      }

      product = await response.json();
      return product;
    } catch (e) {
      console.error('[Preorder] Cannot load product:', e);
      return null;
    }
  }

  function getSelectedSize() {
    const fieldsets = document.querySelectorAll(
      'variant-selects fieldset'
    );

    for (const fieldset of fieldsets) {
      const label = fieldset
        .querySelector('legend')
        ?.innerText
        ?.trim()
        ?.toLowerCase();

      if (label && label.includes('size')) {
        const active = fieldset.querySelector(
          '.bls__option-swatch.active'
        );

        return active?.dataset.value?.trim() || null;
      }
    }

    const active = document.querySelector(
      '.bls__option-swatch.active'
    );

    return active?.dataset.value?.trim() || null;
  }

  function getCurrentVariantFromProduct() {
    const id = getVariantId();

    if (!id || !product?.variants) {
      return null;
    }

    return (
      product.variants.find(v => Number(v.id) === Number(id)) || null
    );
  }

  function getCurrentColor() {
    const current = getCurrentVariantFromProduct();

    if (!current) {
      return null;
    }

    return current.option1?.trim() || null;
  }

  async function resolveSelectedVariant(clickedOption = null) {
    const data = await loadProduct();

    if (!data || !Array.isArray(data.variants)) {
      return null;
    }

    const size =
      clickedOption?.dataset?.value?.trim() ||
      getSelectedSize();

    if (!size) {
      console.log('[Preorder] No size selected');
      return null;
    }

    const color = getCurrentColor();
    let variant = null;

    if (color) {
      variant =
        data.variants.find(v => {
          return (
            String(v.option1 || '').trim() === String(color).trim() &&
            String(v.option2 || '').trim() === String(size).trim()
          );
        }) || null;
    }

    if (!variant) {
      variant =
        data.variants.find(v => {
          return (
            String(v.option1 || '').trim() === String(size).trim()
          );
        }) || null;
    }

    if (variant) {
      console.log(`[Preorder] Resolve ${size} → ${variant.id}`);
    }

    return variant;
  }

  function setVariantId(id) {
    const input = getVariantInput();

    if (!input || !id) {
      return false;
    }

    const oldId = Number(input.value);
    const newId = Number(id);

    if (oldId === newId) {
      currentVariantId = newId;
      return false;
    }

    input.value = String(newId);
    input.setAttribute('value', String(newId));

    currentVariantId = newId;

    return true;
  }

  function isSoldOut(variant) {
    if (!variant) {
      return false;
    }

    const available = variant.available === true;

    const inventory = Number(
      variant.inventoryQuantity ??
      variant.inventory_quantity ??
      0
    );

    return available === false && inventory <= 0;
  }

  function isPreorder(variant) {
    if (!variant) {
      return false;
    }

    const available = variant.available === true;
    const start = Number(variant.start || 0);
    const end = Number(variant.end || 0);

    const inventory = Number(
      variant.inventoryQuantity ??
      variant.inventory_quantity ??
      0
    );

    if (!available) {
      return false;
    }

    return inventory <= 0 && start > 0 && end > 0;
  }

  function syncProperties(variant) {
    if (!variant) {
      return;
    }

    if ($('.bss-po-product-page')) {
      return;
    }

    const form = getForm();

    if (!form) {
      return;
    }

    const status = form.querySelector('#line-item-status');
    const dispatch = form.querySelector('#line-item-dispatch');

    if (!status || !dispatch) {
      return;
    }

    const start = Number(variant.start || 0);
    const end = Number(variant.end || 0);

    if (start && end) {
      dispatch.value = `${formatDate(
        variant.start
      )} - ${formatDate(
        variant.end
      )}`;
    }
  }

  function captureOriginalButtonLabel() {
    const form = getForm();

    if (!form) {
      return;
    }

    const button = form.querySelector(
      'button[type="submit"][name="add"]'
    );

    if (!button) {
      return;
    }

    const text =
      button.querySelector('.hidden-loading') ||
      button.querySelector('[data-add-to-cart-text]') ||
      button;

    if (text.dataset.preorderOriginalLabel) {
      return;
    }

    const label = text.textContent.trim();

    if (
      label &&
      label !== 'KHÔNG CÓ SẴN' &&
      label !== 'HẾT HÀNG'
    ) {
      text.dataset.preorderOriginalLabel = label;
    }
  }

  function updateButton(variant) {
    if (!variant) {
      return;
    }

    const form = getForm();

    if (!form) {
      return;
    }

    const button = form.querySelector(
      'button[type="submit"][name="add"]'
    );

    if (!button) {
      return;
    }

    const text =
      button.querySelector('.hidden-loading') ||
      button.querySelector('[data-add-to-cart-text]') ||
      button;

    if (!text.dataset.preorderOriginalLabel) {
      const currentText = text.textContent.trim();

      if (
        currentText &&
        currentText !== 'KHÔNG CÓ SẴN' &&
        currentText !== 'HẾT HÀNG' &&
        currentText !== 'SOLD OUT'
      ) {
        text.dataset.preorderOriginalLabel = currentText;
      }
    }

    const inventory = Number(
      variant.inventoryQuantity ??
      variant.inventory_quantity ??
      0
    );

    const soldOut = isSoldOut(variant);
    const preorder = isPreorder(variant);

    if (soldOut) {
      button.disabled = true;
      button.setAttribute('disabled', 'disabled');
      button.classList.add('disabled');
      button.classList.add('is-disabled');
      button.setAttribute('aria-disabled', 'true');
      text.textContent = 'SOLD OUT';
      return;
    }

    if (preorder) {
      button.disabled = false;
      button.removeAttribute('disabled');
      button.classList.remove('disabled');
      button.classList.remove('is-disabled');
      button.setAttribute('aria-disabled', 'false');
      text.textContent = 'Thêm vào giỏ hàng';
      return;
    }

    if (variant.available === true && inventory > 0) {
      button.disabled = false;
      button.removeAttribute('disabled');
      button.classList.remove('disabled');
      button.classList.remove('is-disabled');
      button.setAttribute('aria-disabled', 'false');

      const originalLabel = text.dataset.preorderOriginalLabel;

      if (originalLabel) {
        text.textContent = originalLabel;
      }

      return;
    }

    if (variant.available === false) {
      button.disabled = true;
      button.setAttribute('disabled', 'disabled');
      button.classList.add('disabled');
      button.classList.add('is-disabled');
      button.setAttribute('aria-disabled', 'true');
      text.textContent = 'HẾT HÀNG';
      return;
    }
  }

  function forceButtonState(variant) {
    if (!variant) {
      return;
    }

    const form = getForm();

    if (!form) {
      return;
    }

    const button = form.querySelector(
      'button[type="submit"][name="add"]'
    );

    if (!button) {
      return;
    }

    const text =
      button.querySelector('.hidden-loading') ||
      button.querySelector('[data-add-to-cart-text]') ||
      button;

    const inventory = Number(
      variant.inventoryQuantity ??
      variant.inventory_quantity ??
      0
    );

    const soldOut = isSoldOut(variant);
    const preorder = isPreorder(variant);

    if (soldOut) {
      button.disabled = true;
      button.setAttribute('disabled', 'disabled');
      button.classList.add('disabled');
      button.classList.add('is-disabled');
      button.setAttribute('aria-disabled', 'true');
      text.textContent = 'HẾT HÀNG';
      return;
    }

    if (preorder) {
      button.disabled = false;
      button.removeAttribute('disabled');
      button.classList.remove('disabled');
      button.classList.remove('is-disabled');
      button.setAttribute('aria-disabled', 'false');
      text.textContent = 'Thêm vào giỏ hàng';
      return;
    }

    if (variant.available === true && inventory > 0) {
      button.disabled = false;
      button.removeAttribute('disabled');
      button.classList.remove('disabled');
      button.classList.remove('is-disabled');
      button.setAttribute('aria-disabled', 'false');

      const originalLabel = text.dataset.preorderOriginalLabel;

      if (originalLabel) {
        text.textContent = originalLabel;
      }

      return;
    }

    if (variant.available === false) {
      button.disabled = true;
      button.setAttribute('disabled', 'disabled');
      button.classList.add('disabled');
      button.classList.add('is-disabled');
      button.setAttribute('aria-disabled', 'true');
      text.textContent = 'HẾT HÀNG';
    }
  }

  function render() {
    const id = getVariantId();
    const variant = getPreorderVariant(id);
    updateStockNotice(variant);
    const box = $('#preorder-dispatch');

    if (!box) {
      if (variant) {
        syncProperties(variant);
        updateButton(variant);
      }
      return;
    }

    if (!variant) {
      box.style.display = 'none';
      box.innerHTML = '';
      return;
    }

    syncProperties(variant);
    updateButton(variant);

    const soldOut = isSoldOut(variant);
    const preorder = isPreorder(variant);

    const inventory = Number(
      variant.inventoryQuantity ??
      variant.inventory_quantity ??
      0
    );

    if (soldOut) {
      box.style.display = 'none';
      box.innerHTML = '';
      return;
    }

    let start;
    let end;

    if (preorder) {
      start = variant.start;
      end = variant.end;
    } else if (
      variant.available === true &&
      inventory > 0 &&
      box.dataset.dispatchStart &&
      box.dataset.dispatchEnd
    ) {
      start = box.dataset.dispatchStart;
      end = box.dataset.dispatchEnd;
    } else {
      box.style.display = 'none';
      box.innerHTML = '';
      return;
    }

    box.style.display = '';

    box.innerHTML = `
      <div class="preorder-shipping">
        <svg
          xmlns="http://www.w3.org/2000/svg"
          width="24"
          height="24"
          viewBox="0 0 24 24"
          fill="none"
          stroke="currentColor"
          stroke-width="1.8"
          stroke-linecap="round"
          stroke-linejoin="round"
          aria-hidden="true"
        >
          <path d="M3 6h11v11H3z"></path>
          <path d="M14 9h4l3 3v5h-7z"></path>
          <circle cx="7.5" cy="18" r="2"></circle>
          <circle cx="17.5" cy="18" r="2"></circle>
          <path d="M14 13h7"></path>
        </svg>
        Thời gian nhận hàng dự kiến từ
        <strong>${start} - ${end} ngày</strong>
        kể từ khi đặt hàng
      </div>
    `;
  }

  function reapplyAfterTheme(variant) {
    if (!variant) {
      return;
    }

    const check = () => {
      const currentId = getVariantId();

      if (Number(currentId) !== Number(variant.id)) {
        return;
      }

      forceButtonState(variant);
      syncProperties(variant);
    };

    requestAnimationFrame(() => {
      check();

      requestAnimationFrame(() => {
        check();

        requestAnimationFrame(() => {
          check();

          requestAnimationFrame(() => {
            check();
          });
        });
      });
    });
  }

  async function handleSizeClick(clickedOption) {
    if (resolving) {
      return;
    }

    resolving = true;

    try {
      const variant = await resolveSelectedVariant(clickedOption);

      if (!variant) {
        console.warn('[Preorder] Cannot resolve variant');
        return;
      }

      console.log(
        '[Preorder] Variant ID:',
        getVariantId(),
        '→',
        variant.id
      );

      setVariantId(variant.id);

      const preorderVariant = getPreorderVariant(variant.id);

      if (!preorderVariant) {
        console.warn(
          '[Preorder] No preorder data for:',
          variant.id
        );

        return;
      }

      syncProperties(preorderVariant);
      updateButton(preorderVariant);
      render();
      reapplyAfterTheme(preorderVariant);
    } finally {
      resolving = false;
    }
  }

  function syncBeforeAdd() {
    const id = getVariantId();
    const variant = getPreorderVariant(id);

    if (!variant) {
      return;
    }

    syncProperties(variant);
  }

  async function init() {
    await loadProduct();

    captureOriginalButtonLabel();
    render();

    document.addEventListener(
      'click',
      e => {
        const option = e.target.closest('.bls__option-swatch');

        if (!option) {
          return;
        }

        handleSizeClick(option);
      },
      true
    );

    document.addEventListener(
      'change',
      e => {
        if (
          e.target.matches(
            'form[data-type="add-to-cart-form"] input[name="id"]'
          )
        ) {
          render();
        }
      }
    );

    document.addEventListener(
      'variant:change',
      () => {
        setTimeout(() => {
          render();
        }, 0);
      }
    );

    document.addEventListener(
      'click',
      e => {
        const button = e.target.closest(
          'form[data-type="add-to-cart-form"] button[name="add"]'
        );

        if (!button) {
          return;
        }

        syncBeforeAdd();
      },
      true
    );

    document.addEventListener(
      'submit',
      e => {
        const form = e.target.closest(
          'form[data-type="add-to-cart-form"]'
        );

        if (!form) {
          return;
        }

        syncBeforeAdd();
      },
      true
    );
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();